import React, { useState, useEffect } from "react";
import Select from "react-select";
import AdminServices from "services/AdminServices";
import FranchisePageServices from "services/FranchiseService";

const SelectServiceState = ({
  onSelectState,
  name,
  label,
  selectedServiceState = [],
  setSelectedServiceState,
  register,
  required,
  from,
  setFranchiseCities,
  selectedFranchise: franchise_id,
}) => {
  const [states, setStates] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const fetchStates = async () => {
      if (!franchise_id) return;
    try {
      let response;
      if (from === "franchise_partner") {
        response =
          await FranchisePageServices.getServiceStatebyVendor(franchise_id);

        setStates(
          response.data.states.map((state) => ({
            value: state.id,
            label: state.name,
          })),
        );

        setFranchiseCities(response.data.cities);
      } else {
        console.error("API Response is not an array:", response);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  useEffect(() => {
    fetchStates();
  }, [franchise_id]);

  const getSelectedOptions = () => {
    return selectedServiceState
      .map((value) =>
        states.find((state) =>
          typeof value === "object"
            ? state.value === value.value
            : state.value.toString() === value.toString(),
        ),
      )
      .filter(Boolean);
  };

  // Handle selection changes
  const handleStateSelect = (selectedOptions) => {
    const isSelectAllSelected = selectedOptions.some(
      (option) => option.value === "select_all",
    );
    if (isSelectAllSelected) {
      const allStates = states.map((state) => ({
        value: state.value,
        label: state.label,
      }));
      setSelectedServiceState(allStates); // Select all states
      onSelectState(allStates); // Notify parent of the change
      setAllSelected(true);
    } else {
      setSelectedServiceState(selectedOptions); // Update parent state
      onSelectState(selectedOptions); // Notify parent of the change
      setAllSelected(false);
    }
  };

  const options = [{ value: "select_all", label: "Select States" }, ...states];

  const customStyles = {
    indicatorsContainer: (provided) => ({
      ...provided,
      padding: "0", // Optional: Adjust padding
    }),
    indicatorSeparator: () => ({
      display: "none", // Removes the separator line
    }),
  };

  return (
    <div>
      {label && <label className="block text-sm font-medium">{label}</label>}
      <Select
        {...register(`${name}`, {
          ...(required && {
            required: `${label} is required!`,
          }),
        })}
        isMulti
        name={name}
        options={options} // Include "Select All" option
        value={allSelected ? states : getSelectedOptions()} // Pre-select values
        onChange={handleStateSelect} // Handle changes
        placeholder="Select States"
        classNamePrefix="react-select"
        className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
        styles={customStyles}
      />
    </div>
  );
};

export default SelectServiceState;
